import { get } from 'packs/plugins/axios'
export const fetchCoordinates = (params) => get(`/api/v1/coordinates`, params)